import { GrowthDataSet } from '../../types/data-set.types';

export const whoBoysHeightMonthly: GrowthDataSet = {
  id: 'who-boys-height-monthly',
  source: 'WHO',
  title: 'Height-for-age',
  intervalType: 'month',
  gender: 'male',
  measurementType: 'height',
  ageRange: { min: 0, max: 60 },
  displayUnit: 'cm',
  dataPoints: [
    {
      age: 0,
      m: 49.8842,
      s: 0.03795,
      sd: 1.8931,
      percentiles: {
        p1: 45.5,
        p3: 46.3,
        p5: 46.8,
        p15: 47.9,
        p25: 48.6,
        p50: 49.9,
        p75: 51.2,
        p85: 51.8,
        p95: 53,
        p97: 53.4,
        p99: 54.3,
      },
    },
    {
      age: 1,
      m: 54.7244,
      s: 0.03557,
      sd: 1.9465,
      percentiles: {
        p1: 50.2,
        p3: 51.1,
        p5: 51.5,
        p15: 52.7,
        p25: 53.4,
        p50: 54.7,
        p75: 56,
        p85: 56.7,
        p95: 57.9,
        p97: 58.4,
        p99: 59.3,
      },
    },
    {
      age: 2,
      m: 58.4249,
      s: 0.03424,
      sd: 2.0005,
      percentiles: {
        p1: 53.8,
        p3: 54.7,
        p5: 55.1,
        p15: 56.4,
        p25: 57.1,
        p50: 58.4,
        p75: 59.8,
        p85: 60.5,
        p95: 61.7,
        p97: 62.2,
        p99: 63.1,
      },
    },
    {
      age: 3,
      m: 61.4292,
      s: 0.03328,
      sd: 2.0444,
      percentiles: {
        p1: 56.7,
        p3: 57.6,
        p5: 58.1,
        p15: 59.3,
        p25: 60.1,
        p50: 61.4,
        p75: 62.8,
        p85: 63.5,
        p95: 64.8,
        p97: 65.3,
        p99: 66.2,
      },
    },
    {
      age: 4,
      m: 63.886,
      s: 0.03257,
      sd: 2.0808,
      percentiles: {
        p1: 59,
        p3: 60,
        p5: 60.5,
        p15: 61.7,
        p25: 62.5,
        p50: 63.9,
        p75: 65.3,
        p85: 66,
        p95: 67.3,
        p97: 67.8,
        p99: 68.7,
      },
    },
    {
      age: 5,
      m: 65.9026,
      s: 0.03204,
      sd: 2.1115,
      percentiles: {
        p1: 61,
        p3: 61.9,
        p5: 62.4,
        p15: 63.7,
        p25: 64.5,
        p50: 65.9,
        p75: 67.3,
        p85: 68.1,
        p95: 69.4,
        p97: 69.9,
        p99: 70.8,
      },
    },
    {
      age: 6,
      m: 67.6236,
      s: 0.03165,
      sd: 2.1403,
      percentiles: {
        p1: 62.6,
        p3: 63.6,
        p5: 64.1,
        p15: 65.4,
        p25: 66.2,
        p50: 67.6,
        p75: 69.1,
        p85: 69.8,
        p95: 71.1,
        p97: 71.6,
        p99: 72.6,
      },
    },
    {
      age: 7,
      m: 69.1645,
      s: 0.03139,
      sd: 2.1711,
      percentiles: {
        p1: 64.1,
        p3: 65.1,
        p5: 65.6,
        p15: 66.9,
        p25: 67.7,
        p50: 69.2,
        p75: 70.6,
        p85: 71.4,
        p95: 72.7,
        p97: 73.2,
        p99: 74.2,
      },
    },
    {
      age: 8,
      m: 70.5994,
      s: 0.03124,
      sd: 2.2055,
      percentiles: {
        p1: 65.5,
        p3: 66.5,
        p5: 67,
        p15: 68.3,
        p25: 69.1,
        p50: 70.6,
        p75: 72.1,
        p85: 72.9,
        p95: 74.2,
        p97: 74.7,
        p99: 75.7,
      },
    },
    {
      age: 9,
      m: 71.9687,
      s: 0.03117,
      sd: 2.2433,
      percentiles: {
        p1: 66.8,
        p3: 67.7,
        p5: 68.3,
        p15: 69.6,
        p25: 70.5,
        p50: 72,
        p75: 73.5,
        p85: 74.3,
        p95: 75.7,
        p97: 76.2,
        p99: 77.2,
      },
    },
    {
      age: 10,
      m: 73.2812,
      s: 0.03118,
      sd: 2.2849,
      percentiles: {
        p1: 68,
        p3: 69,
        p5: 69.5,
        p15: 70.9,
        p25: 71.7,
        p50: 73.3,
        p75: 74.8,
        p85: 75.6,
        p95: 77,
        p97: 77.6,
        p99: 78.6,
      },
    },
    {
      age: 11,
      m: 74.5388,
      s: 0.03125,
      sd: 2.3293,
      percentiles: {
        p1: 69.1,
        p3: 70.2,
        p5: 70.7,
        p15: 72.1,
        p25: 73,
        p50: 74.5,
        p75: 76.1,
        p85: 77,
        p95: 78.4,
        p97: 78.9,
        p99: 80,
      },
    },
    {
      age: 12,
      m: 75.7488,
      s: 0.03137,
      sd: 2.3762,
      percentiles: {
        p1: 70.2,
        p3: 71.3,
        p5: 71.8,
        p15: 73.3,
        p25: 74.1,
        p50: 75.7,
        p75: 77.4,
        p85: 78.2,
        p95: 79.7,
        p97: 80.2,
        p99: 81.3,
      },
    },
    {
      age: 13,
      m: 76.9186,
      s: 0.03154,
      sd: 2.426,
      percentiles: {
        p1: 71.3,
        p3: 72.4,
        p5: 72.9,
        p15: 74.4,
        p25: 75.3,
        p50: 76.9,
        p75: 78.6,
        p85: 79.4,
        p95: 80.9,
        p97: 81.5,
        p99: 82.6,
      },
    },
    {
      age: 14,
      m: 78.0497,
      s: 0.03174,
      sd: 2.4773,
      percentiles: {
        p1: 72.3,
        p3: 73.4,
        p5: 74,
        p15: 75.5,
        p25: 76.4,
        p50: 78,
        p75: 79.7,
        p85: 80.6,
        p95: 82.1,
        p97: 82.7,
        p99: 83.8,
      },
    },
    {
      age: 15,
      m: 79.1458,
      s: 0.03197,
      sd: 2.5303,
      percentiles: {
        p1: 73.3,
        p3: 74.4,
        p5: 75,
        p15: 76.5,
        p25: 77.4,
        p50: 79.1,
        p75: 80.9,
        p85: 81.8,
        p95: 83.3,
        p97: 83.9,
        p99: 85,
      },
    },
    {
      age: 16,
      m: 80.2113,
      s: 0.03222,
      sd: 2.5844,
      percentiles: {
        p1: 74.2,
        p3: 75.4,
        p5: 76,
        p15: 77.5,
        p25: 78.5,
        p50: 80.2,
        p75: 82,
        p85: 82.9,
        p95: 84.5,
        p97: 85.1,
        p99: 86.2,
      },
    },
    {
      age: 17,
      m: 81.2487,
      s: 0.0325,
      sd: 2.6406,
      percentiles: {
        p1: 75.1,
        p3: 76.3,
        p5: 76.9,
        p15: 78.5,
        p25: 79.5,
        p50: 81.2,
        p75: 83,
        p85: 84,
        p95: 85.6,
        p97: 86.2,
        p99: 87.4,
      },
    },
    {
      age: 18,
      m: 82.2587,
      s: 0.03279,
      sd: 2.6973,
      percentiles: {
        p1: 76,
        p3: 77.2,
        p5: 77.8,
        p15: 79.5,
        p25: 80.4,
        p50: 82.3,
        p75: 84.1,
        p85: 85.1,
        p95: 86.7,
        p97: 87.3,
        p99: 88.5,
      },
    },
    {
      age: 19,
      m: 83.2418,
      s: 0.0331,
      sd: 2.7553,
      percentiles: {
        p1: 76.8,
        p3: 78.1,
        p5: 78.7,
        p15: 80.4,
        p25: 81.4,
        p50: 83.2,
        p75: 85.1,
        p85: 86.1,
        p95: 87.8,
        p97: 88.4,
        p99: 89.7,
      },
    },
    {
      age: 20,
      m: 84.1996,
      s: 0.03342,
      sd: 2.814,
      percentiles: {
        p1: 77.7,
        p3: 78.9,
        p5: 79.6,
        p15: 81.3,
        p25: 82.3,
        p50: 84.2,
        p75: 86.1,
        p85: 87.1,
        p95: 88.8,
        p97: 89.5,
        p99: 90.7,
      },
    },
    {
      age: 21,
      m: 85.1348,
      s: 0.03376,
      sd: 2.8742,
      percentiles: {
        p1: 78.4,
        p3: 79.7,
        p5: 80.4,
        p15: 82.2,
        p25: 83.2,
        p50: 85.1,
        p75: 87.1,
        p85: 88.1,
        p95: 89.9,
        p97: 90.5,
        p99: 91.8,
      },
    },
    {
      age: 22,
      m: 86.0477,
      s: 0.0341,
      sd: 2.9342,
      percentiles: {
        p1: 79.2,
        p3: 80.5,
        p5: 81.2,
        p15: 83,
        p25: 84.1,
        p50: 86,
        p75: 88,
        p85: 89.1,
        p95: 90.9,
        p97: 91.6,
        p99: 92.9,
      },
    },
    {
      age: 23,
      m: 86.941,
      s: 0.03445,
      sd: 2.9951,
      percentiles: {
        p1: 80,
        p3: 81.3,
        p5: 82,
        p15: 83.8,
        p25: 84.9,
        p50: 86.9,
        p75: 89,
        p85: 90,
        p95: 91.9,
        p97: 92.6,
        p99: 93.9,
      },
    },
    {
      age: 24,
      m: 87.8161,
      s: 0.03479,
      sd: 3.0551,
      percentiles: {
        p1: 80,
        p3: 81.4,
        p5: 82.1,
        p15: 83.9,
        p25: 85.1,
        p50: 87.1,
        p75: 89.2,
        p85: 90.3,
        p95: 92.1,
        p97: 92.9,
        p99: 94.2,
      },
    },
    {
      age: 25,
      m: 87.972,
      s: 0.03542,
      sd: 3.116,
      percentiles: {
        p1: 80.7,
        p3: 82.1,
        p5: 82.8,
        p15: 84.7,
        p25: 85.9,
        p50: 88,
        p75: 90.1,
        p85: 91.2,
        p95: 93.1,
        p97: 93.8,
        p99: 95.2,
      },
    },
    {
      age: 26,
      m: 88.8065,
      s: 0.03576,
      sd: 3.1757,
      percentiles: {
        p1: 81.4,
        p3: 82.8,
        p5: 83.6,
        p15: 85.5,
        p25: 86.7,
        p50: 88.8,
        p75: 90.9,
        p85: 92.1,
        p95: 94,
        p97: 94.8,
        p99: 96.2,
      },
    },
    {
      age: 27,
      m: 89.6197,
      s: 0.0361,
      sd: 3.2353,
      percentiles: {
        p1: 82.1,
        p3: 83.5,
        p5: 84.3,
        p15: 86.3,
        p25: 87.4,
        p50: 89.6,
        p75: 91.8,
        p85: 93,
        p95: 94.9,
        p97: 95.7,
        p99: 97.1,
      },
    },
    {
      age: 28,
      m: 90.412,
      s: 0.03642,
      sd: 3.2928,
      percentiles: {
        p1: 82.8,
        p3: 84.2,
        p5: 85,
        p15: 87,
        p25: 88.2,
        p50: 90.4,
        p75: 92.6,
        p85: 93.8,
        p95: 95.8,
        p97: 96.6,
        p99: 98.1,
      },
    },
    {
      age: 29,
      m: 91.1828,
      s: 0.03674,
      sd: 3.3501,
      percentiles: {
        p1: 83.4,
        p3: 84.9,
        p5: 85.7,
        p15: 87.7,
        p25: 88.9,
        p50: 91.2,
        p75: 93.4,
        p85: 94.7,
        p95: 96.7,
        p97: 97.5,
        p99: 99,
      },
    },
    {
      age: 30,
      m: 91.9327,
      s: 0.03704,
      sd: 3.4052,
      percentiles: {
        p1: 84,
        p3: 85.5,
        p5: 86.3,
        p15: 88.4,
        p25: 89.6,
        p50: 91.9,
        p75: 94.2,
        p85: 95.5,
        p95: 97.5,
        p97: 98.3,
        p99: 99.9,
      },
    },
    {
      age: 31,
      m: 92.6631,
      s: 0.03733,
      sd: 3.4591,
      percentiles: {
        p1: 84.6,
        p3: 86.2,
        p5: 87,
        p15: 89.1,
        p25: 90.3,
        p50: 92.7,
        p75: 95,
        p85: 96.2,
        p95: 98.4,
        p97: 99.2,
        p99: 100.7,
      },
    },
    {
      age: 32,
      m: 93.3753,
      s: 0.03761,
      sd: 3.5118,
      percentiles: {
        p1: 85.2,
        p3: 86.8,
        p5: 87.6,
        p15: 89.7,
        p25: 91,
        p50: 93.4,
        p75: 95.7,
        p85: 97,
        p95: 99.2,
        p97: 100,
        p99: 101.5,
      },
    },
    {
      age: 33,
      m: 94.0711,
      s: 0.03787,
      sd: 3.5625,
      percentiles: {
        p1: 85.8,
        p3: 87.4,
        p5: 88.2,
        p15: 90.4,
        p25: 91.7,
        p50: 94.1,
        p75: 96.5,
        p85: 97.8,
        p95: 99.9,
        p97: 100.8,
        p99: 102.4,
      },
    },
    {
      age: 34,
      m: 94.7532,
      s: 0.03812,
      sd: 3.612,
      percentiles: {
        p1: 86.4,
        p3: 88,
        p5: 88.8,
        p15: 91,
        p25: 92.3,
        p50: 94.8,
        p75: 97.2,
        p85: 98.5,
        p95: 100.7,
        p97: 101.5,
        p99: 103.2,
      },
    },
    {
      age: 35,
      m: 95.4236,
      s: 0.03836,
      sd: 3.6604,
      percentiles: {
        p1: 86.9,
        p3: 88.5,
        p5: 89.4,
        p15: 91.6,
        p25: 93,
        p50: 95.4,
        p75: 97.9,
        p85: 99.2,
        p95: 101.4,
        p97: 102.3,
        p99: 103.9,
      },
    },
    {
      age: 36,
      m: 96.0835,
      s: 0.03858,
      sd: 3.7069,
      percentiles: {
        p1: 87.5,
        p3: 89.1,
        p5: 90,
        p15: 92.2,
        p25: 93.6,
        p50: 96.1,
        p75: 98.6,
        p85: 99.9,
        p95: 102.2,
        p97: 103.1,
        p99: 104.7,
      },
    },
    {
      age: 37,
      m: 96.7337,
      s: 0.03879,
      sd: 3.7523,
      percentiles: {
        p1: 88,
        p3: 89.7,
        p5: 90.6,
        p15: 92.8,
        p25: 94.2,
        p50: 96.7,
        p75: 99.3,
        p85: 100.6,
        p95: 102.9,
        p97: 103.8,
        p99: 105.5,
      },
    },
    {
      age: 38,
      m: 97.3749,
      s: 0.039,
      sd: 3.7976,
      percentiles: {
        p1: 88.5,
        p3: 90.2,
        p5: 91.1,
        p15: 93.4,
        p25: 94.8,
        p50: 97.4,
        p75: 99.9,
        p85: 101.3,
        p95: 103.6,
        p97: 104.5,
        p99: 106.2,
      },
    },
    {
      age: 39,
      m: 98.0073,
      s: 0.03919,
      sd: 3.8409,
      percentiles: {
        p1: 89.1,
        p3: 90.8,
        p5: 91.7,
        p15: 94,
        p25: 95.4,
        p50: 98,
        p75: 100.6,
        p85: 102,
        p95: 104.3,
        p97: 105.2,
        p99: 106.9,
      },
    },
    {
      age: 40,
      m: 98.631,
      s: 0.03937,
      sd: 3.8831,
      percentiles: {
        p1: 89.6,
        p3: 91.3,
        p5: 92.2,
        p15: 94.6,
        p25: 96,
        p50: 98.6,
        p75: 101.3,
        p85: 102.7,
        p95: 105,
        p97: 105.9,
        p99: 107.7,
      },
    },
    {
      age: 41,
      m: 99.2459,
      s: 0.03954,
      sd: 3.9242,
      percentiles: {
        p1: 90.1,
        p3: 91.9,
        p5: 92.8,
        p15: 95.2,
        p25: 96.6,
        p50: 99.2,
        p75: 101.9,
        p85: 103.3,
        p95: 105.7,
        p97: 106.6,
        p99: 108.4,
      },
    },
    {
      age: 42,
      m: 99.8515,
      s: 0.03971,
      sd: 3.9651,
      percentiles: {
        p1: 90.6,
        p3: 92.4,
        p5: 93.3,
        p15: 95.7,
        p25: 97.2,
        p50: 99.9,
        p75: 102.5,
        p85: 104,
        p95: 106.4,
        p97: 107.3,
        p99: 109.1,
      },
    },
    {
      age: 43,
      m: 100.4485,
      s: 0.03986,
      sd: 4.0039,
      percentiles: {
        p1: 91.1,
        p3: 92.9,
        p5: 93.9,
        p15: 96.3,
        p25: 97.7,
        p50: 100.4,
        p75: 103.1,
        p85: 104.6,
        p95: 107,
        p97: 108,
        p99: 109.8,
      },
    },
    {
      age: 44,
      m: 101.0374,
      s: 0.04002,
      sd: 4.0435,
      percentiles: {
        p1: 91.6,
        p3: 93.4,
        p5: 94.4,
        p15: 96.8,
        p25: 98.3,
        p50: 101,
        p75: 103.8,
        p85: 105.2,
        p95: 107.7,
        p97: 108.6,
        p99: 110.4,
      },
    },
    {
      age: 45,
      m: 101.6186,
      s: 0.04016,
      sd: 4.081,
      percentiles: {
        p1: 92.1,
        p3: 93.9,
        p5: 94.9,
        p15: 97.4,
        p25: 98.9,
        p50: 101.6,
        p75: 104.4,
        p85: 105.8,
        p95: 108.3,
        p97: 109.3,
        p99: 111.1,
      },
    },
    {
      age: 46,
      m: 102.1933,
      s: 0.04031,
      sd: 4.1194,
      percentiles: {
        p1: 92.6,
        p3: 94.4,
        p5: 95.4,
        p15: 97.9,
        p25: 99.4,
        p50: 102.2,
        p75: 105,
        p85: 106.5,
        p95: 109,
        p97: 109.9,
        p99: 111.8,
      },
    },
    {
      age: 47,
      m: 102.7625,
      s: 0.04045,
      sd: 4.1567,
      percentiles: {
        p1: 93.1,
        p3: 94.9,
        p5: 95.9,
        p15: 98.5,
        p25: 100,
        p50: 102.8,
        p75: 105.6,
        p85: 107.1,
        p95: 109.6,
        p97: 110.6,
        p99: 112.4,
      },
    },
    {
      age: 48,
      m: 103.3273,
      s: 0.04059,
      sd: 4.1941,
      percentiles: {
        p1: 93.6,
        p3: 95.4,
        p5: 96.4,
        p15: 99,
        p25: 100.5,
        p50: 103.3,
        p75: 106.2,
        p85: 107.7,
        p95: 110.2,
        p97: 111.2,
        p99: 113.1,
      },
    },
    {
      age: 49,
      m: 103.8886,
      s: 0.04073,
      sd: 4.2314,
      percentiles: {
        p1: 94,
        p3: 95.9,
        p5: 96.9,
        p15: 99.5,
        p25: 101,
        p50: 103.9,
        p75: 106.7,
        p85: 108.3,
        p95: 110.8,
        p97: 111.8,
        p99: 113.7,
      },
    },
    {
      age: 50,
      m: 104.4473,
      s: 0.04086,
      sd: 4.2677,
      percentiles: {
        p1: 94.5,
        p3: 96.4,
        p5: 97.4,
        p15: 100,
        p25: 101.6,
        p50: 104.4,
        p75: 107.3,
        p85: 108.9,
        p95: 111.5,
        p97: 112.5,
        p99: 114.4,
      },
    },
    {
      age: 51,
      m: 105.0041,
      s: 0.041,
      sd: 4.3052,
      percentiles: {
        p1: 95,
        p3: 96.9,
        p5: 97.9,
        p15: 100.5,
        p25: 102.1,
        p50: 105,
        p75: 107.9,
        p85: 109.5,
        p95: 112.1,
        p97: 113.1,
        p99: 115,
      },
    },
    {
      age: 52,
      m: 105.5596,
      s: 0.04113,
      sd: 4.3417,
      percentiles: {
        p1: 95.5,
        p3: 97.4,
        p5: 98.4,
        p15: 101.1,
        p25: 102.6,
        p50: 105.6,
        p75: 108.5,
        p85: 110.1,
        p95: 112.7,
        p97: 113.7,
        p99: 115.7,
      },
    },
    {
      age: 53,
      m: 106.1138,
      s: 0.04126,
      sd: 4.3783,
      percentiles: {
        p1: 95.9,
        p3: 97.9,
        p5: 98.9,
        p15: 101.6,
        p25: 103.2,
        p50: 106.1,
        p75: 109.1,
        p85: 110.7,
        p95: 113.3,
        p97: 114.3,
        p99: 116.3,
      },
    },
    {
      age: 54,
      m: 106.6668,
      s: 0.04139,
      sd: 4.4149,
      percentiles: {
        p1: 96.4,
        p3: 98.4,
        p5: 99.4,
        p15: 102.1,
        p25: 103.7,
        p50: 106.7,
        p75: 109.6,
        p85: 111.2,
        p95: 113.9,
        p97: 115,
        p99: 116.9,
      },
    },
    {
      age: 55,
      m: 107.2188,
      s: 0.04152,
      sd: 4.4517,
      percentiles: {
        p1: 96.9,
        p3: 98.8,
        p5: 99.9,
        p15: 102.6,
        p25: 104.2,
        p50: 107.2,
        p75: 110.2,
        p85: 111.8,
        p95: 114.5,
        p97: 115.6,
        p99: 117.6,
      },
    },
    {
      age: 56,
      m: 107.7697,
      s: 0.04165,
      sd: 4.4886,
      percentiles: {
        p1: 97.3,
        p3: 99.3,
        p5: 100.4,
        p15: 103.1,
        p25: 104.7,
        p50: 107.8,
        p75: 110.8,
        p85: 112.4,
        p95: 115.2,
        p97: 116.2,
        p99: 118.2,
      },
    },
    {
      age: 57,
      m: 108.3198,
      s: 0.04177,
      sd: 4.5245,
      percentiles: {
        p1: 97.8,
        p3: 99.8,
        p5: 100.9,
        p15: 103.6,
        p25: 105.3,
        p50: 108.3,
        p75: 111.4,
        p85: 113,
        p95: 115.8,
        p97: 116.8,
        p99: 118.8,
      },
    },
    {
      age: 58,
      m: 108.8689,
      s: 0.0419,
      sd: 4.5616,
      percentiles: {
        p1: 98.3,
        p3: 100.3,
        p5: 101.4,
        p15: 104.1,
        p25: 105.8,
        p50: 108.9,
        p75: 111.9,
        p85: 113.6,
        p95: 116.4,
        p97: 117.4,
        p99: 119.5,
      },
    },
    {
      age: 59,
      m: 109.417,
      s: 0.04202,
      sd: 4.5977,
      percentiles: {
        p1: 98.7,
        p3: 100.8,
        p5: 101.9,
        p15: 104.7,
        p25: 106.3,
        p50: 109.4,
        p75: 112.5,
        p85: 114.2,
        p95: 117,
        p97: 118.1,
        p99: 120.1,
      },
    },
    {
      age: 60,
      m: 109.9638,
      s: 0.04214,
      sd: 4.6339,
      percentiles: {
        p1: 99.2,
        p3: 101.2,
        p5: 102.3,
        p15: 105.2,
        p25: 106.8,
        p50: 110,
        p75: 113.1,
        p85: 114.8,
        p95: 117.6,
        p97: 118.7,
        p99: 120.7,
      },
    },
  ],
};
